export default "__VITE_ASSET__DHtbLPnf__"